import React from "react";
import style from "./Footer.module.scss";
import { withRouter, useRouteMatch } from "react-router-dom";

export function Footer() {
    let matchProjection = useRouteMatch("/course/projection");

    // 投屏不显示页脚
    if (matchProjection) return null;

    return (
        <div className={style.root}>
            <p>Copyright©东北财经大学 All Rights Reserved.</p>
            <p>技术支持: 东北财经大学网络教育学院</p>
        </div>
    );
}

export default withRouter(Footer);
